import Box from "@mui/material/Box";
import * as React from "react";
import { WeeklyDriverShiftsRow } from "../../../api";
import {
    ExpandableTable,
    HeadCell,
} from "../../../components/table/expandableTable";
import {
    LoadingTableElement,
    NullTableElement,
} from "../../../components/table/nullTable";
import { Permission } from "../../../literals";
import {
    convertFloatToPercentage,
    convertMinToDisplayFormat,
    convertToMonthDay,
    formatPaymentAmountDisplay,
} from "../../../services/common/convert";
import * as service from "../../../services/weekly/weeklyreport";
import { ExpandableMap } from "./Map/ExpandableMap";
import { SideInfoBar } from "./SideInfoBar";
import { DetailReportState, TripDetails, TripReportsDict } from "./store";

interface Props {
    weeklydetail: DetailReportState;
    permissions: Permission[];
}
interface MapTableProps {
    weeklydetail: DetailReportState;
    permissions: Permission[];
}
interface CustomProps {
    data?: DetailTableRow;
    trips: TripReportsDict | null;
    neighborsOn: boolean;
    tripDetails: TripDetails | null;
    shiftId: string | null;
    neighbors: any;
    permissions: Permission[];
    expandedContainer: string | null;
    viewingNeighbors: boolean;
}

export class DropdownMap extends React.Component<CustomProps> {
    constructor(props: any) {
        super(props);
    }

    container;

    componentDidMount = () => {
        if (this.container) {
            /* TODO: 
            These are other ways to scroll to the Div.
            Figure out least buggy one.
            
            (this.container as HTMLDivElement).scrollIntoView({
              block: "center",
            });
            
            (this.container as HTMLDivElement).scrollTo({
               top: 50,
               left: 50,
            });
            */
            const outerDiv = document.getElementById("StyledModal-outer");

            const headerOffset = 200;
            const containerPosition = (this
                .container as HTMLDivElement).getBoundingClientRect().top;
            const offsetPosition =
                containerPosition + window.pageYOffset - headerOffset;

            console.log("OFFSET..", containerPosition, offsetPosition);
            outerDiv?.scrollTo({
                top: offsetPosition,
                behavior: "smooth",
            });

            const ctr = this.container as HTMLDivElement;
            if (ctr) {
                ctr.onclick = function (ev) {
                    const shiftid = ctr.id.split("map_for_")[1];
                    console.debug("Clicked map:", shiftid);
                    service.setExpandedContainerName(shiftid);
                    service.selectShiftId(shiftid);
                };
            }
        }
    };

    render = () => {
        const currentShiftId = this.props.shiftId ? this.props.shiftId : "";
        const thisMapsTrips = this.props.trips
            ? this.props.trips[currentShiftId]
            : null;

        console.debug(
            "Dropdown map container:",
            this.container,
            currentShiftId,
            this.props.expandedContainer,
            this.props.data,
            this.props
        );

        // comment this out if we want to hide all the other maps we are not looking at
        //  return <Box></Box>;

        return (
            <Box
                id={`map_for_${currentShiftId}`}
                ref={(el) => (this.container = el)}
                sx={{
                    width: "100%",
                }}
            >
                {
                    <ExpandableMap
                        shiftId={currentShiftId}
                        thisMapsTrips={thisMapsTrips}
                        neighborsOn={this.props.neighborsOn}
                        tripDetails={this.props.tripDetails}
                        neighbors={this.props.neighbors}
                        permissions={this.props.permissions}
                        expandedMap={this.props.expandedContainer}
                        viewingNeighbors={this.props.viewingNeighbors}
                    />
                }
            </Box>
        );
    };
}

export const DriverShiftsView: React.FC<Props> = (props: Props) => {
    return (
        <>
            <SideInfoBar {...props} />
            <WeeklyShiftsTable
                weeklydetail={props.weeklydetail}
                permissions={props.permissions}
                expandedIds={props.weeklydetail.expandedContainers}
            />
        </>
    );
};

interface CustomTableProps extends MapTableProps {
    expandedIds: string[];
}
interface MapTableProps {
    weeklydetail: DetailReportState;
    permissions: Permission[];
}

interface ExpandableProps extends MapTableProps {
    id: string;
}

const ExpandableComponent: React.FC<ExpandableProps> = (
    props: ExpandableProps
) => {
    return (
        <Box>
            <DropdownMap
                trips={service.organizeTripsByShift(
                    props.weeklydetail.driverTripsByShift
                )}
                neighbors={props.weeklydetail.neighborsPerTrip}
                neighborsOn={props.weeklydetail.neighborsViewingIsOn}
                tripDetails={props.weeklydetail.selectedTripDetails}
                shiftId={props.weeklydetail.selectedShiftId}
                permissions={props.permissions}
                expandedContainer={props.weeklydetail.expandedContainerName}
                viewingNeighbors={props.weeklydetail.neighborsViewingIsOn}
            />
        </Box>
    );
};

const WeeklyShiftsTable: React.FC<CustomTableProps> = (
    props: CustomTableProps
) => {
    const worstShiftId = props.weeklydetail.detailHeaderInfo
        ? props.weeklydetail.detailHeaderInfo.worst_shift_id
        : "";

    const rows = convertToTableData(
        props.weeklydetail.detailReports,
        worstShiftId
    );

    const handleExpand = (r: DetailTableRow) => {
        service.turnNeighborSwitchOff();
        service.setExpandedContainerName(r.shift_id);
        service.selectShiftId(r.shift_id);
        service.selectTripDetails(r.worstTripId, r.worstTripStartTS);
        service.getGoCancels();
        service.getNeighborsPerTrip();
    };

    const handleUnexpand = (r: DetailTableRow) => {
        service.turnNeighborSwitchOff();
        service.setExpandedContainerName(null);
    };

    // keep for future use
    const handleRowClick = (r: DetailTableRow) => {};

    if (!props.weeklydetail.detailReports) {
        return <LoadingTableElement />;
    }

    if (props.weeklydetail.detailReports.length == 0) {
        return <NullTableElement />;
    }

    return (
        <Box
            id="WeeklyDetailTable"
            sx={{
                pt: 35,
                pl: "300px",
            }}
        >
            <ExpandableTable
                tableHeaders={headCells}
                tableData={rows}
                tableProps={props}
                initialSortColumn={"shift_date"}
                initialSortDirection={"asc"}
                rowIdField={"shift_id"}
                expandableComponent={ExpandableComponent}
                onExpandMethod={handleExpand}
                onUnexpandMethod={handleUnexpand}
                onRowClickMethod={handleRowClick}
                expandableProps={{
                    weeklydetail: props.weeklydetail,
                    permissions: props.permissions,
                }}
            />
        </Box>
    );
};

const convertToTableData = (
    reports: WeeklyDriverShiftsRow[] | null,
    worst_shift_id: string | null
): DetailTableRow[] => {
    if (!reports) {
        return [];
    }
    const _data = reports.map((rec: WeeklyDriverShiftsRow) => {
        const expanded = rec.shiftId == worst_shift_id;
        return {
            driver_name: rec.driverName,
            driver_code: rec.driverCode,
            driver_id: rec.driverId,
            shift_date: rec.shiftStartDt,
            office_id: rec.officeId,
            comment: rec.instructionMessage,
            comment_priority: rec.instructionPriority,
            rides: rec.numTrips,
            revenue: rec.totalShiftRevenue,
            office_avg_revenue: rec.officeTotalAmountPerShift,
            navi_usage_rate: rec.hermesUsingRate,
            shift_length: rec.shiftMin,
            break_length: rec.breakMin,
            shift_id: rec.shiftId,
            defaultExpanded: expanded,
            worstTripId: rec.worstUnladenTripSessionId,
            worstTripStartTS: rec.worstUnladenStartTs,
        } as DetailTableRow;
    });

    return _data;
};

const headCells: HeadCell[] = [
    {
        id: "shift_date",
        grow: 1,
        wrap: true,
        align: "right",
        format: (x: number): string => {
            return convertToMonthDay(x.toString());
        },
        numeric: false,
        headerAlignRight: false,
        label: "日付",
    },
    {
        label: "改善コメント",
        id: "comment_priority",
        numeric: false,
        grow: 4,
        wrap: true,
        displayField: "comment",
        format: (x: number): string => {
            return `${x}`;
        },
    },
    {
        label: "実車回数",
        id: "rides",
        grow: 1,
        align: "right",
        numeric: true,
        format: (x: number): string => {
            return `${x}回`;
        },
    },
    {
        label: "営収",
        id: "revenue",
        grow: 1,
        align: "right",
        numeric: true,
        format: (x: number): string => {
            return formatPaymentAmountDisplay(x, true);
        },
    },
    {
        label: "営業所平均",
        id: "office_avg_revenue",
        grow: 1,
        align: "right",
        numeric: true,
        format: (x: number): string => {
            return formatPaymentAmountDisplay(x, true);
        },
    },
    {
        label: "ナビ利用率",
        id: "navi_usage_rate",
        grow: 1,
        align: "right",
        numeric: true,
        format: (x: number): string => {
            return convertFloatToPercentage(x);
        },
    },
    {
        label: "乗務時間",
        id: "shift_length",
        grow: 1,
        wrap: true,
        align: "right",
        numeric: true,
        format: (x: number): string => {
            return convertMinToDisplayFormat(x);
        },
    },
    {
        label: "停車時間",
        id: "break_length",
        grow: 1,
        align: "right",
        numeric: true,
        format: (x: number): string => {
            return convertMinToDisplayFormat(x);
        },
    },
    {
        id: "empty_cell",
        grow: 1,
        wrap: true,
        align: "right",
        numeric: true,
        disablePadding: true,
        label: " ",
    },
];

export type DetailTableRow = {
    driver_name: string;
    driver_code: string;
    driver_id: number;
    shift_date: string;
    shift_id: string;
    office_id: number;
    comment: string;
    comment_priority: number;
    rides: number;
    revenue: number;
    office_avg_revenue: number;
    navi_usage_rate: number;
    shift_length: number;
    break_length: number;
    defaultExpanded: boolean;
    worstTripId: string;
    worstTripStartTS: string;
};
